'use client';
import { useState, useEffect } from 'react';
import { useLang } from '@/app/lib/lang-context';

export default function PopupLeadMagnet() {
  const { tx, lang } = useLang();
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Afficher après 15 secondes, seulement si pas déjà vu
    const seen = localStorage.getItem('aureus_popup_seen');
    if (seen) return;
    const timer = setTimeout(() => setVisible(true), 15000);
    return () => clearTimeout(timer);
  }, []);

  const close = () => {
    setVisible(false);
    localStorage.setItem('aureus_popup_seen', '1');
  };

  const submit = async () => {
    if (!email) return;
    setLoading(true);
    try {
      await fetch('/api/lead-capture', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source: 'popup_lead_magnet', lang }),
      });
      setSent(true);
      localStorage.setItem('aureus_popup_seen', '1');
    } catch { setSent(true); }
    setLoading(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24, fontFamily: 'system-ui, sans-serif',
    }}>
      <div style={{
        background: '#fff', borderRadius: 20, maxWidth: 480, width: '100%',
        padding: 40, position: 'relative', boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }}>
        {/* Bouton fermer */}
        <button onClick={close} style={{
          position: 'absolute', top: 16, right: 16, background: 'none',
          border: 'none', fontSize: 22, cursor: 'pointer', color: '#999', lineHeight: 1,
        }}>×</button>

        {sent ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🎉</div>
            <h3 style={{ fontSize: 22, fontWeight: 800, color: '#1a1a18', marginBottom: 8 }}>
              {tx('C\'est dans votre boîte !')}
            </h3>
            <p style={{ fontSize: 15, color: '#666', lineHeight: 1.7 }}>
              {tx('Vérifiez votre email — votre guide arrive dans les prochaines minutes.')}
            </p>
            <button onClick={close} style={{
              marginTop: 20, background: '#1a1a18', color: '#c6a34e',
              border: 'none', borderRadius: 8, padding: '12px 28px',
              fontWeight: 700, cursor: 'pointer', fontSize: 15,
            }}>{tx('Fermer')}</button>
          </div>
        ) : (
          <>
            <div style={{
              background: '#c6a34e18', borderRadius: 10, padding: '8px 14px',
              fontSize: 11, fontWeight: 700, color: '#c6a34e',
              textTransform: 'uppercase', letterSpacing: 2, display: 'inline-block', marginBottom: 16,
            }}>{tx('Guide gratuit')}</div>

            <h2 style={{ fontSize: 24, fontWeight: 900, color: '#1a1a18', margin: '0 0 12px', lineHeight: 1.3 }}>
              {tx('La paie belge,')} <span style={{ color: '#c6a34e' }}>{tx('sans y passer vos soirées')}</span>
            </h2>

            <p style={{ fontSize: 14, color: '#666', lineHeight: 1.7, marginBottom: 24 }}>
              {/* ⚠️ 07/09/2026 — On ne promet QUE ce qu'on envoie réellement.
                  L'ancien texte annonçait « réduisez vos charges de 30% » et « les
                  7 aides que 80% des PME n'utilisent pas » : trois chiffres jamais
                  sourcés (R1/R2), pour un guide qui n'existait nulle part et n'a
                  jamais été envoyé. Le guide réellement expédié décrit ce que fait
                  l'app — cf. app/lib/guide-gratuit-mail.js. */}
              {tx('Recevez notre guide gratuit : ce que le logiciel prend en charge pour votre entreprise, de la paie aux déclarations ONSS.')}
            </p>

            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              {/* Les puces annoncent ce que le guide contient RÉELLEMENT (cf.
                  app/lib/guide-gratuit-mail.js). Les anciennes (« Activa.brussels »,
                  « Bonus emploi », « Réductions CP ») promettaient un guide d'aides
                  à l'emploi qui n'a jamais existé. */}
              {['✅ Paie & fiches', '✅ Dimona & DmfA', '✅ Contrats'].map(item => (
                <span key={item} style={{
                  background: '#eef7ee', color: '#16a34a', fontSize: 11,
                  fontWeight: 600, padding: '4px 10px', borderRadius: 20,
                }}>{tx(item)}</span>
              ))}
            </div>

            <input
              type="email"
              placeholder={tx('Votre email professionnel')}
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && submit()}
              style={{
                width: '100%', padding: '14px 16px', fontSize: 15,
                border: '1.5px solid #e0ddd5', borderRadius: 10,
                outline: 'none', marginBottom: 12, boxSizing: 'border-box',
                fontFamily: 'system-ui, sans-serif',
              }}
            />

            <button
              onClick={submit}
              disabled={loading || !email}
              style={{
                width: '100%', background: email ? '#1a1a18' : '#ccc',
                color: email ? '#c6a34e' : '#fff', border: 'none',
                borderRadius: 10, padding: '15px', fontWeight: 800,
                fontSize: 16, cursor: email ? 'pointer' : 'not-allowed',
              }}
            >
              {loading ? tx('Envoi...') : tx('Recevoir le guide gratuit →')}
            </button>

            <p style={{ fontSize: 11, color: '#aaa', textAlign: 'center', marginTop: 12 }}>
              {tx('Aucun spam. Désabonnement en 1 clic. Données protégées RGPD.')}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
